module.exports = __webpack_public_path__ + "static/media/fw2.0cd24b7b.png";